webpackJsonp([267508049536846],{

/***/ 408:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/the-farm-project-lettuce-grow-logo.8f401daf.svg";

/***/ }),

/***/ 409:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/your-foods-roots.f85c54ae.svg";

/***/ }),

/***/ 168:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _yourFoodsRoots = __webpack_require__(409);
	
	var _yourFoodsRoots2 = _interopRequireDefault(_yourFoodsRoots);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var marked = __webpack_require__(12);
	
	exports.default = function (_ref) {
	    var data = _ref.data;
	    return _react2.default.createElement(
	        'div',
	        { className: 'collaborations__closer' },
	        _react2.default.createElement(
	            'div',
	            { className: 'lettucegrowicon' },
	            _react2.default.createElement(
	                'a',
	                { target: '_blank', href: data.secondUrl },
	                _react2.default.createElement('img', { src: _yourFoodsRoots2.default })
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'newsletter' },
	            _react2.default.createElement(
	                'div',
	                { className: 'contactus__content' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'collaborations__closer__still' },
	                    _react2.default.createElement(
	                        'a',
	                        { target: '_blank', href: data.secondUrl },
	                        _react2.default.createElement('img', { src: data.secondImage.file.url })
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'main__content__copy' },
	                    _react2.default.createElement(
	                        'h3',
	                        null,
	                        data.secondHeading,
	                        _react2.default.createElement('br', null),
	                        data.secondHeadingLineTwo
	                    ),
	                    _react2.default.createElement('div', {
	                        className: 'main__content__copy__inner',
	                        dangerouslySetInnerHTML: {
	                            __html: marked(data.secondText.secondText, {
	                                gfm: true,
	                                breaks: true
	                            })
	                        }
	                    }),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'collaborations__link' },
	                        _react2.default.createElement(
	                            'a',
	                            { target: '_blank', href: data.secondUrl },
	                            data.secondCallToActionText,
	                            _react2.default.createElement('i', { className: 'fas fa-chevron-right' })
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 169:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _theFarmProjectLettuceGrowLogo = __webpack_require__(408);
	
	var _theFarmProjectLettuceGrowLogo2 = _interopRequireDefault(_theFarmProjectLettuceGrowLogo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var marked = __webpack_require__(12);
	
	exports.default = function (_ref) {
	    var data = _ref.data;
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'hero' },
	            _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement('div', { className: 'hero__background' }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'hero__content' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'hero__title' },
	                        data.heroHeading
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'hero__copy' },
	                        _react2.default.createElement('div', {
	                            dangerouslySetInnerHTML: {
	                                __html: marked(data.heroText.heroText, {
	                                    gfm: true,
	                                    breaks: true
	                                })
	                            }
	                        })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'collaborations__link' },
	                        _react2.default.createElement(
	                            'a',
	                            { href: data.heroUrl, target: '_blank' },
	                            data.heroCallToActionText,
	                            _react2.default.createElement('i', { className: 'fas fa-chevron-right' })
	                        )
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'yourfoodsroots' },
	            _react2.default.createElement(
	                'a',
	                { target: '_blank', href: data.mainUrl },
	                _react2.default.createElement('img', { src: _theFarmProjectLettuceGrowLogo2.default })
	            )
	        )
	    );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 170:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(354);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var marked = __webpack_require__(12);
	
	exports.default = function (_ref) {
	    var data = _ref.data;
	    return _react2.default.createElement(
	        'div',
	        { className: 'main' },
	        _react2.default.createElement(
	            'div',
	            { className: 'main__content' },
	            _react2.default.createElement(
	                'div',
	                { className: 'main__content__still' },
	                _react2.default.createElement(
	                    'a',
	                    { target: '_blank', href: data.mainUrl },
	                    _react2.default.createElement('img', { src: data.mainImage.file.url })
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'main__content__copy' },
	                _react2.default.createElement(
	                    'h1',
	                    { className: 'main__content__headline' },
	                    data.mainHeading,
	                    _react2.default.createElement('br', null),
	                    data.mainHeadingLineTwo
	                ),
	                _react2.default.createElement('div', {
	                    className: 'main__content__copy__inner',
	                    dangerouslySetInnerHTML: {
	                        __html: marked(data.mainText.mainText, {
	                            gfm: true,
	                            breaks: true
	                        })
	                    }
	                }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'collaborations__link' },
	                    _react2.default.createElement(
	                        'a',
	                        { target: '_blank', href: data.mainUrl },
	                        data.mainCallToActionText,
	                        _react2.default.createElement('i', { className: 'fas fa-chevron-right' })
	                    )
	                )
	            )
	        )
	    );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 354:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 180:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _helmetBuilder = __webpack_require__(19);
	
	var _helmetBuilder2 = _interopRequireDefault(_helmetBuilder);
	
	var _collaborationsHero = __webpack_require__(169);
	
	var _collaborationsHero2 = _interopRequireDefault(_collaborationsHero);
	
	var _collaborationsMain = __webpack_require__(170);
	
	var _collaborationsMain2 = _interopRequireDefault(_collaborationsMain);
	
	var _collaborationsCloser = __webpack_require__(168);
	
	var _collaborationsCloser2 = _interopRequireDefault(_collaborationsCloser);
	
	__webpack_require__(362);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage(_ref) {
	    var data = _ref.data,
	        location = _ref.location;
	    return _react2.default.createElement(
	        'div',
	        { className: 'collaborations' },
	        _react2.default.createElement(_helmetBuilder2.default, { data: data.collaborations.edges[0].node, pathname: location.pathname }),
	        _react2.default.createElement(_collaborationsHero2.default, { data: data.collaborations.edges[0].node }),
	        _react2.default.createElement(_collaborationsMain2.default, { data: data.collaborations.edges[0].node }),
	        _react2.default.createElement(_collaborationsCloser2.default, { data: data.collaborations.edges[0].node })
	    );
	};
	
	// <OurPartners data={data.collaborations.edges[0].node} /> //was under CollaborationsCloser
	
	//import OurPartners from '../components/our-partners';
	
	exports.default = IndexPage;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ }),

/***/ 362:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-collaborations-js-44714c855792ed5e3145.js